// extracted by mini-css-extract-plugin
module.exports = {"title":"RecipeDetailsSection_title__J1atq","useFade-fadeIn":"RecipeDetailsSection_useFade-fadeIn__XI84S","useFade-fadeOut":"RecipeDetailsSection_useFade-fadeOut__ZB67O"};